import SearchCategory from './SearchCategory.jsx';

export {
  SearchCategory
}


// WEBPACK FOOTER //
// ./components/category-detail/search-category/index.js